// extracted by mini-css-extract-plugin
module.exports = {"container":"QuickMenu_container__3bUG2","list":"QuickMenu_list__Fwx79","title":"QuickMenu_title__3X68Z"};